module.exports = __webpack_public_path__ + "img/wallpaper_jp.34dd7808.png";